import { AHText, Box } from "arkh";
import React, { useMemo } from "react";
import { IntegrationAdminListItem } from "./components/IntegrationAdminListItem";
import { graphql, useFragment } from "react-relay";

import { IntegrationAdminServiceAccountsListItem_Store$key } from "./__generated__/IntegrationAdminServiceAccountsListItem_Store.graphql";
import { FormattedMessage } from "react-intl";

export function IntegrationAdminServiceAccountsListItem(props: {
  isFirst: boolean;
  isLast: boolean;
  onPress(): void;
  store: IntegrationAdminServiceAccountsListItem_Store$key;
}) {
  const data = useFragment(
    graphql`
      fragment IntegrationAdminServiceAccountsListItem_Store on Store {
        serviceAccounts {
          __typename
          authTokens {
            expiresAt {
              isoString
            }
          }
        }
      }
    `,
    props.store
  );

  const status = useMemo(() => {
    const expiredCount = data.serviceAccounts.filter((serviceAccount) =>
      serviceAccount.authTokens.find(
        (authToken) =>
          authToken.expiresAt &&
          new Date(authToken.expiresAt.isoString) < new Date()
      )
    ).length;

    if (expiredCount >= data.serviceAccounts.length) {
      return "negative";
    } else if (expiredCount > 0) {
      return "semiNegative";
    }

    return "positive";
  }, [data.serviceAccounts]);

  return (
    <IntegrationAdminListItem
      isFirst={props.isFirst}
      isLast={props.isLast}
      onPress={props.onPress}
      status={status}
    >
      <Box style={{ flexDirection: "row", flex: 1, alignItems: "center" }}>
        <AHText type="list-item-title">
          <FormattedMessage
            description="IntegrationAdminServiceAccountsListItem - title"
            defaultMessage="External Services"
          />
        </AHText>
        <Box style={{ flex: 1 }} />
        <AHText type="body">{data.serviceAccounts.length}</AHText>
      </Box>
    </IntegrationAdminListItem>
  );
}
